export class CreatePullRequestInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "body",
            "baseName": "body",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreatePullRequestInput.attributeTypeMap;
    }
    constructor() {
    }
}
